import { render, staticRenderFns } from "./ParameterPassingLogList.vue?vue&type=template&id=390b97b8&scoped=true"
import script from "./ParameterPassingLogList.vue?vue&type=script&lang=js"
export * from "./ParameterPassingLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390b97b8",
  null
  
)

export default component.exports